import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, { onClick: _ctx.closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.closeOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Export product threshold jobs')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_reorder_group, {
          onIonItemReorder: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doReorder($event))),
          disabled: "false"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modifiedJobs, (job) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: job.jobId
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(job.jobName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.timeTillJob(job.runTime)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (_ctx.successJobs.includes(job.jobId))
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: _ctx.checkmarkCircleOutline,
                        color: "success"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  (_ctx.failedJobs.includes(job.jobId))
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: _ctx.closeCircleOutline,
                        color: "danger"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_reorder)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_fab, {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_fab_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
              disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE) || _ctx.failedJobs.length || _ctx.isReordering
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { icon: _ctx.saveOutline }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}